<template>
	<div class="webview-pet-weather">
		<sorry-page v-if="isError" @reload="getData" class="webview-pet-weather__inner" />

		<div v-else-if="isMount" class="webview-pet-weather__inner">
			<!-- ヘッダー -->
			<h1 class="webview-pet-weather__title">{{ cityName }}</h1>

			<!-- ペット天気予報 -->
			<section class="webview-pet-weather__item">
				<pet-weather />
			</section>
			<!-- /ペット天気予報 -->
		</div>
	</div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_USER_ID, SET_USER_TOKEN, SET_USER_DATA, SET_IS_WEBVIEW, SET_S3_CITY_CODE_DATA } from '../store/modules/common/mutation-types'

// ライブラリ
import cmnConst from '@/assets/js/constant.js'
import MunicipalCodeUtil from '@/utils/municipal-code-util'

// Compornents
import PetWeather from '@/components/Organisms/PetWeather'
import SorryPage from '@/views/SorryPage'

export default {
	name: 'WebviewPetWeather',
	components: {
		PetWeather,
		SorryPage
	},
	data () {
		return {
			isError: false,
			isMount: false,
			userId: null,
			userToken: null,
			cityName: ''
		}
	},
	created () {
		// OnsenUIのbody要素に付与されているstyleを打ち消す
		const style = document.body.getAttribute('style')
		document.body.setAttribute('style', `${style} position: inherit; overflow: auto;`)

		// storeにwebviewフラグを立てる
		this.SET_IS_WEBVIEW(true)
		// URLパラメータをチェック
		const state = this.$route.query.state ? this.$route.query.state.toString() : ''
		const stateArray = state.split(cmnConst.SEPARATOR)
		if (state === 'error' || state === '') {
			// 認証エラー
			console.log('state error: ', state)
			this.isError = true
		} else if (stateArray.length !== 2) {
			// 認証パラメータエラー
			console.log('state length error: ', state)
			this.isError = true
		} else {
			// URLパラメータからユーザーID、ユーザートークンを取得する
			this.userId = stateArray[0]
			this.userToken = stateArray[1]
			this.SET_USER_ID(this.userId)
			this.SET_USER_TOKEN(this.userToken)

			// APIリクエスト処理
			this.getData()
		}
	},
	mounted () {
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userData', 's3CityCodeData'])
	},
	methods: {
		// map Vuex actions
		...mapActions('common', [SET_USER_ID, SET_USER_TOKEN, SET_IS_WEBVIEW, SET_USER_DATA, SET_S3_CITY_CODE_DATA]),

		// データ取得処理
		getData () {
			// 状態の初期化
			this.isError = false
			this.isMount = false

			// NOTE: ユーザー情報とS3の地点データを取得したら子コンポーネントをマウントする（必ずここで取得するのでユーザー情報/課金タイプ/S3地点データがあるかどうかの判定はしない）
			const SET_USER_DATA = this.SET_USER_DATA({
				user_id: this.userId,
				user_token: this.userToken
			})
			const SET_S3_CITY_CODE_DATA = this.SET_S3_CITY_CODE_DATA()
			Promise.all([SET_USER_DATA, SET_S3_CITY_CODE_DATA]).then(res => {
				console.log('userData: ', this.userData)
				// console.log('s3CityCodeData: ', this.s3CityCodeData)

				// 現在地の設定
				const municipalCodeUtil = new MunicipalCodeUtil(this.s3CityCodeData)
				this.cityName = municipalCodeUtil.getMunicipalData(this.userData.city_code).name

				// マウント
				this.isMount = true
			}).catch(error => {
				// ユーザー情報取得エラー
				console.log('userData error: ', error)
				this.isError = true
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~swiper/css/swiper.min.css';
@import "../assets/sass/variable";

// NOTE: このページ限定の変数（デザインシステム外のため他での利用禁止）
$color-background: #F1F1F1;
$color-grey: #E6E6E6;
$color-orange: #FFAD00;
$spacing-12: 0.75rem;
$text-grey: #999;

.webview-pet-weather {
	.content {
		background-color: $color-background !important;
		padding-bottom: $spacing-20;
	}
	&__inner { font-family: $family-primary; }

	&__title {
		min-height: 24px;
		margin: 0;
		padding: $spacing-6 $spacing-10;
		font-family: $lp-family-tertiary;
		font-size: $font-size-12;
		line-height: $line-height-1;
		text-align: center;
		background-color: $color-grey;
		box-sizing: border-box;
		font-weight: normal;
	}

	&__item {
		margin: 0;
		padding: 0;
	}
}
</style>
